  <div *ngIf="errorMessage" class="bg-white mb-5 mt-5 py-5 text-center error-container heading-4">
     <img class="mb-3" src="assets/themes/icons/restricted-content-placeholder.svg" alt="restricted" />
     <br>
    <span class="color-grey-500">{{errorMessage}}</span>
  </div>
  <div *ngIf="isFinished" class="text-center">
    <img class="text-center mt-4" src="assets/themes/images/img-video-loader.gif" width="40" height="40" alt="loader">
  </div>
  <div class="ncp-back-btn heading-4" *ngIf="gameNCPProduct && gameNCPProduct.product_type === productType.NCP_SUB_TYPE" (click)="goBack()">
    <img class="mr-3" width="20" src="assets/themes/icons/back-arrow.svg" alt="Back" />
    <span class="color-grey-700">{{mls.languageText.game_detail.key1}}</span>
  </div>
  <div class="ncp-banner d-flex mb-3" *ngIf="gameNCPProduct && gameNCPProduct.product_type === productType.NCP_SUB_TYPE">
    <div class="ncp-banner__profile-container position-relative">
      <div class="ncp-banner__content">
        <div class="ncp-banner__content__detail">
          <div class="ncp-banner__content-game">
            <div class="clearfix">
              <span class="ncp-profile__pic float-left">
                <img [src]="gameNCPProduct.image.icon" alt="Profile icon" />
              </span>
              <div class="ncp-profile-detail">
                <h3 class="heading-3 ellipsis mb-2 heading-width" [ngStyle]="{'color':gameDetailTemplate.color.title}">
                  {{gameNCPProduct.title}}
                </h3>
                <div class="paragraph d-flex" [ngStyle]="{
                    'color':gameDetailTemplate.color.sponser_category
                  }">
                  <span class="ncp-profile__pharma-icon mr-2">
                    <img [src]="gameNCPProduct.sponser_details.image" 
                      onerror="this.src='assets/themes/icons/sponsor-placeholder.svg'"
                      alt="icon" />
                  </span>
                  {{mls.languageText.ncp_card_screen.key8}} {{gameNCPProduct.sponser_details.name}}
                </div>
                <div class="secondary-paragraph mt-2" [ngStyle]="{
                    'color':gameDetailTemplate.color.sponser_category
                  }">
                  <span>{{gameNCPProduct.category_name}}</span>
                  <div class="d-block d-lg-none">
                    <ng-container *ngIf="gameNCPProduct?.specialities.length > numbers.ZERO">
                      <span class="w-100px pr-2" *ngFor="let specialty of gameNCPProduct.specialities">
                        {{this.specialCharacter.HASH}}{{specialty?.speciality_name}}
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <button class="ncp-banner__content__game-play btn-design medium filled" (click)="navigateToGameScreen()" [appAnalyticsEvent]="analyticsPlayNowData"
              [ngStyle]="{'background-image': 'linear-gradient(to bottom,' + gameDetailTemplate.color.card_cta + ' 0%, '+ gameDetailTemplate.color.card_cta_another + ' 97%)',
                'color':gameDetailTemplate.color.card_cta_text}">
              {{gameDetailTemplate.text.product_button_text}}
            </button>
          </div>
          <div class="d-none d-lg-block p-94px secondary-paragraph mt-1" [ngStyle]="{
              'color':gameDetailTemplate.color.sponser_category
            }">
            <ng-container *ngIf="gameNCPProduct?.specialities.length > numbers.ZERO">
              <span class="specialty pr-2" *ngFor="let specialty of gameNCPProduct.specialities">
                {{this.specialCharacter.HASH}}{{specialty?.speciality_name}}
              </span>
            </ng-container>
          </div>
          <div class="ncp-game-info secondary-paragraph" [ngStyle]="{
            'color':gameDetailTemplate.color.sponser_category
            }">
            <div class="ncp-game-info__others-action d-flex align-items-center">
              <span class="cursor-pointer" 
                (click)="getProductLikeList()">{{gameNCPProduct.count.like}} {{mls.languageText.ncp_card_screen.key2}}</span>
              <span class="separator" [ngStyle]="{
                'background-color':gameDetailTemplate.color.sponser_category
              }"></span>
              <span>{{gameNCPProduct.count.comment}} {{mls.languageText.ncp_card_screen.key4}}</span>
            </div>
            <div class="ncp-game-info__time-played d-flex align-items-center">
              <span class="played-by mr-2">
                <img [src]="gameNCPProduct.image.play_image" alt="Players icon" />
              </span>
              <span>{{gameNCPProduct.count.play_count}}{{gameDetailTemplate.text.play_count}}</span>
            </div>
          </div>
        </div>
        <div class="ncp-banner__content__actions pb-3" [ngStyle]="{
            'color':gameDetailTemplate.color.like_comment_share
          }">
          <span (click)="likeProduct()"  [appAnalyticsEvent]="analyticsLikeData" [ngClass]="{'liked': gameNCPProduct.is_liked === numbers.ONE}" class="button cursor-pointer" [ngStyle]="{
              'color':gameNCPProduct.is_liked === numbers.ONE ? gameDetailTemplate.color.liked_color : gameDetailTemplate.color.like_comment_share
            }">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" class="svg-postion">
              <defs>
                <style>
                  .liked-card-icon {
                    fill: {{gameNCPProduct.is_liked===numbers.ONE ? gameDetailTemplate.color.liked_color: gameDetailTemplate.color.like_comment_share}};
                  }
                </style>
              </defs>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.61204 8.6093L0.612013 8.60927C0.335865 8.60926 0.112 8.83312 0.112 9.10927V10.1093V16.9442V17.9442C0.112 18.2203 0.335857 18.4442 0.611999 18.4442H1.612H14.4017C14.9286 18.4442 15.4786 18.3135 15.9523 17.9773C16.437 17.6334 16.7476 17.1391 16.8727 16.5968C16.9761 16.1485 16.9508 15.7055 16.8372 15.2886C17.1025 14.9959 17.3179 14.6425 17.445 14.2235C17.6207 13.6444 17.5888 13.0778 17.4086 12.5523C17.72 12.189 17.9545 11.752 18.056 11.2317C18.1644 10.6764 18.0967 10.1489 17.9232 9.66591C18.2007 9.28028 18.3825 8.83846 18.4555 8.39072C18.6321 7.30761 18.1727 6.06446 16.8779 5.50182L16.5919 5.37754L16.2801 5.37755L9.78713 5.37761L9.91479 2.68605C9.98132 1.28318 8.86187 0.109375 7.45743 0.109375C6.3363 0.109375 5.35698 0.867372 5.07589 1.95269L3.35184 8.60934L1.61204 8.6093ZM15.0317 14.7592C14.9666 14.787 14.9451 14.871 14.9893 14.9263C15.3526 15.3821 15.4878 15.8486 15.4197 16.2181C15.3407 16.6463 14.9886 16.9442 14.4017 16.9442H4.57093V9.88506L6.52797 2.32877C6.63768 1.9052 7.01988 1.60938 7.45743 1.60938C8.00555 1.60938 8.44244 2.06748 8.41647 2.61498L8.28544 5.37763L8.23913 6.35393C8.22561 6.63906 8.45313 6.87762 8.73858 6.87762L9.71598 6.87761L16.2801 6.87755C17.0657 7.21891 17.148 8.04782 16.7882 8.66345C16.6394 8.91802 16.4151 9.13613 16.1336 9.2682C16.0703 9.29788 16.0478 9.38016 16.0906 9.43535C16.435 9.87894 16.6072 10.3046 16.6074 10.6968C16.6075 10.8587 16.5783 11.0148 16.5198 11.1642C16.3755 11.5328 16.053 11.86 15.5525 12.1293C15.4921 12.1619 15.4785 12.2439 15.525 12.2944C15.9088 12.712 16.0673 13.1161 16.0591 13.4784C16.0562 13.6046 16.0331 13.7257 15.9923 13.8405C15.8509 14.2385 15.4963 14.5612 15.0317 14.7592ZM3.07093 10.1093V16.9442H1.612V15.4442V11.6093V10.1093L3.07093 10.1093Z" class="liked-card-icon"/>
            </svg>
            <span class="ml-2">{{gameNCPProduct.is_liked===numbers.ONE ? mls.languageText.ncp_card_screen.key7: mls.languageText.ncp_card_screen.key1}}</span>
          </span>
          <span class="button cursor-pointer" (click)="scroll('cmment-container')" [appAnalyticsEvent]="analyticsCommentData" [ngStyle]="{
            'color':gameDetailTemplate.color.like_comment_share
          }">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" class="svg-postion">
              <defs>
                <style>
                  .comment-icon {
                    fill: {{gameDetailTemplate.color.like_comment_share}};
                  }
                </style>
              </defs>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3019 17.2734H5.30188C4.19731 17.2734 3.30188 16.378 3.30188 15.2734V5.27344C3.30188 4.16887 4.19731 3.27344 5.30188 3.27344H19.3019C20.4064 3.27344 21.3019 4.16887 21.3019 5.27344V21.2734L15.3019 17.2734ZM19.8019 18.4707L15.756 15.7734H5.30188C5.02574 15.7734 4.80188 15.5496 4.80188 15.2734V5.27344C4.80188 4.9973 5.02574 4.77344 5.30188 4.77344H19.3019C19.578 4.77344 19.8019 4.9973 19.8019 5.27344V18.4707Z" class="comment-icon"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3019 9.27344H7.30188V7.77344H16.3019V9.27344Z" class="comment-icon"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3019 13.2734H10.3019V11.7734H16.3019V13.2734Z" class="comment-icon"/>
            </svg>
           <span class="ml-2">{{mls.languageText.ncp_card_screen.key4}}</span>
          </span>
          <span class="button cursor-pointer" (click)="shareProduct()" 
            [appAnalyticsEvent]="analyticsShareData" 
            [ngStyle]="{
            'color':gameDetailTemplate.color.like_comment_share
          }">
          <svg width="25" height="20" viewBox="0 0 25 20" fill="none" class="svg-postion">
            <defs>
              <style>
                .share-icon {
                  fill: {{gameDetailTemplate.color.like_comment_share}};
                }
              </style>
            </defs>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8499 1.25768C14.2093 0.633507 13.1334 1.08735 13.1334 1.9817V5.55602C10.7353 5.57542 6.75758 6.07383 3.86009 8.89837C1.08813 11.5986 0.737589 15.1061 0.711237 18.2401C0.706646 18.7862 1.10073 19.112 1.42111 19.2161C1.73834 19.3192 2.22347 19.288 2.54538 18.8828C3.27971 17.9587 6.30716 14.7539 13.1334 14.9963V18.5631C13.1334 19.4143 14.1209 19.8844 14.7816 19.3479L19.8283 15.2494L24.0628 11.8106C24.5323 11.4293 24.5642 10.7239 24.131 10.3018L14.8499 1.25768ZM14.9174 3.81444L22.2639 10.9733L18.7037 13.8645L14.9174 16.9394V14.2624C14.9174 13.7143 14.4871 13.2892 13.9741 13.254C8.05923 12.8481 4.47015 14.7752 2.57111 16.3443C2.75763 14.0132 3.35414 11.8816 5.10513 10.1761C7.80321 7.54592 11.7581 7.27498 13.8714 7.3498C14.4548 7.37045 14.9174 6.90057 14.9174 6.33903V3.81444Z" class="share-icon" />
            </svg>
            <span class="ml-2">{{mls.languageText.ncp_card_screen.key5}}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="ncp-banner__container">
      <img class="game-banner" 
      [src]="gameNCPProduct.template.image.web_detail_banner" 
      onerror="this.src='assets/images/game/game_placeholder.jpg'" 
      alt="game banner" />
    </div>
  </div>
  <div class="row ncp-mobile-view" *ngIf="gameNCPProduct && gameNCPProduct.product_type === productType.NCP_SUB_TYPE">
    <div class="col-lg-7 col-md-6 col-adjusted">
      <div class="bg-white ncp-game-slides mb-3" *ngIf="gameNCPProduct.image.screenshots.length">
        <div class="custom-owl-carousel">
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngIf="gameNCPProduct?.image?.screenshots.length > numbers.ZERO">
            <ng-template carouselSlide *ngFor="let item of gameNCPProduct.image.screenshots">
              <div class="ncp-game-slides__banner" 
                [ngClass]="{'single-card' : gameNCPProduct.image.screenshots.length === numbers.ONE }">
                <img class="ncp-game-slides__banner-image" 
                  onerror="this.src='assets/images/game/game_placeholder.jpg'"  
                  [src]="item" 
                  alt="Banner" />
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
        </div>
      </div>
      <div class="bg-white cmment-container mb-3" *ngIf="gameNCPProduct.comment_flag === numbers.ONE">
        <h3 class="p-3 heading-4 brder-bottom">{{mls.languageText.ncp_card_screen.key4}}</h3>
        <div class="px-3 pt-3">
          <app-product-comment-box 
            [comment_box_obj]="comment_box_obj" 
            (resetComment)="resetComment($event)"
            [callingFrom]="ScreenName" 
            [emitUserComment]="emitUserComment">
          </app-product-comment-box>
        </div>
        <div class="brder-top">
        <app-product-comment 
          (resetCmtList)="resetCmtList($event)" 
          [commentObj]="commentObj" 
          [callingFrom]="ScreenName"
          [list_type]="numbers.TWO" 
          [comment_box_obj]="comment_box_obj" 
          [showCommentBox]="numbers.ZERO"
          (emitComment)="emitComment($event)">
        </app-product-comment>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-md-6 pl-md-0 pb-3 col-adjusted">
      <app-leaderboard 
        [gameId]="ncpProductId" 
        [playersCount]="gameNCPProduct.count.player_count">
      </app-leaderboard>
    </div>
  </div>
  
  <!-- like list popup start**************************** -->
  <app-product-like *ngIf="showLikeListModal"
      (resetLikeModalList)="resetLikeModalList($event)"
      (resetLike)="resetLike($event)"
      [likeObj]="likeObject">
  </app-product-like>
  <!-- like list popup end ***************************** -->